import { create } from "zustand";
import { apiRequest } from "@/lib/api";

export interface UserApplication {
  id: string;
  appName: string;
  description: string;
  icon: string;
  iconKey?: string;
  app_url: string;
  route: string;
  usersgroups: string[];
  isActive: boolean;
}

interface UserApplicationsState {
  applications: UserApplication[];
  loading: boolean;
  refreshing: boolean;
  error: string;
  loaded: boolean;
  loadApplications: (force?: boolean) => Promise<void>;
  refreshApplications: () => Promise<void>;
  clearApplications: () => void;
}

export const useUserApplicationsStore = create<UserApplicationsState>()((set, get) => ({
  applications: [],
  loading: false,
  refreshing: false,
  error: "",
  loaded: false,

  loadApplications: async (force = false) => {
    const { loaded, loading } = get();
    if (!force && (loaded || loading)) {
      return;
    }

    const isInitialLoad = !loaded;
    set({
      loading: isInitialLoad ? true : loading,
      refreshing: isInitialLoad ? false : true,
      error: "",
    });
    try {
      const data = await apiRequest<UserApplication[]>("/applications");
      set({
        applications: Array.isArray(data) ? data : [],
        loading: false,
        refreshing: false,
        error: "",
        loaded: true,
      });
    } catch (err) {
      set({
        applications: [],
        loading: false,
        refreshing: false,
        error: err instanceof Error ? err.message : "Failed to load applications",
        loaded: false,
      });
    }
  },

  refreshApplications: async () => {
    await get().loadApplications(true);
  },

  clearApplications: () => {
    set({
      applications: [],
      loading: false,
      refreshing: false,
      error: "",
      loaded: false,
    });
  },
}));
